var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-schema-form', { attrs: { "schema": _vm.schema, "model": _vm.model } });
};
var staticRenderFns = [];

export { render, staticRenderFns };